import type { OrganizationDetail } from '@viewer/protocol';
import { useState, type FormEvent } from 'react';
import { api, errorText } from '../../lib/api/client';
import styles from './org.module.css';

interface Props {
  canCancel: boolean;
  onCancel(): void;
  onCreated(org: OrganizationDetail): Promise<void>;
}

export function CreateOrgForm({ canCancel, onCancel, onCreated }: Props) {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const org = await api.post<OrganizationDetail>('/api/orgs', { name: name.trim() });
      await onCreated(org);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className={styles.panel} style={{ width: 'min(440px, 100%)' }}>
      <h2 className={styles.panelTitle}>Criar empresa</h2>
      <p className={styles.help}>
        A empresa é a dona dos computadores. Você será o proprietário e poderá convidar colaboradores, organizar os
        computadores em grupos e definir quem acessa o quê.
      </p>
      <form className={styles.form} onSubmit={submit}>
        <label className={styles.field}>
          <span className={styles.label}>Nome da empresa</span>
          <input
            className={styles.input}
            autoFocus
            required
            maxLength={80}
            placeholder="Ex.: Supermercado Central"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.actions}>
          {canCancel && (
            <button type="button" className={`${styles.btn} ${styles.btnSecondary}`} onClick={onCancel} disabled={busy}>
              Cancelar
            </button>
          )}
          <button type="submit" className={`${styles.btn} ${styles.btnPrimary}`} disabled={busy || !name.trim()}>
            {busy ? 'Criando...' : 'Criar empresa'}
          </button>
        </div>
      </form>
    </section>
  );
}
